import { SxProps } from '@mui/material';
import { ROUTE_API } from './route-util';

export const requiredRules = {
  required: { value: true, message: 'Field is required' },
};

export const validatePatterns = {
  phoneNumber: /0[0-9]{8}$|0[0-9]{9}$/,
  numberOnly: /^-?[0-9]\d*(\.\d+)?$/,
  positiveNumberOnly: /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/,
  positiveNumberOnlyandEmpty: /$^|^[0-9]\d*(\.\d+)?\.?$/,
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
  textOnly: /^[a-zA-Z ]*$/,
};

// format separateComma
export const separateComma = (val: number) => {
  // remove sign if negative
  var sign = 1;
  if (val < 0) {
    sign = -1;
    val = -val;
  }
  // trim the number decimal point if it exists
  let num = val.toString().includes('.')
    ? val.toString().split('.')[0]
    : val.toString();
  let len = num.toString().length;
  let result = '';
  let count = 1;

  for (let i = len - 1; i >= 0; i--) {
    result = num.toString()[i] + result;
    if (count % 3 === 0 && count !== 0 && i !== 0) {
      result = ',' + result;
    }
    count++;
  }

  // add number after decimal point
  if (val.toString().includes('.')) {
    result = result + '.' + val.toString().split('.')[1];
  }
  // return result with - sign if negative
  return sign < 0 ? '-' + result : result;
};

// format background color
export function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name: string, sx?: SxProps) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      ...sx,
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

// format invoice id
export const formatInvoiceId = (value: string) => {
  const pad = '00000';
  return pad.substring(0, pad.length - value.length) + value;
};
// format data
export const compactNumberFormatter = (number: number) => {
  return Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(number);
};
export const currencyFormatter = (number: number) => {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(number);
};

export function getImage(imgUrl?: string) {
  return imgUrl ? `${ROUTE_API.baseUrl + ROUTE_API.getImage + imgUrl}` : '';
}

export function cutImagePath(path: string) {
  return path.replace(`${ROUTE_API.baseUrl + ROUTE_API.getImage}`, '');
}

// export const pageStyle = `
//   @page {
//     size: A4;
//     margin: 1.5cm; /* Slightly reduced for better fit */
//   }

//   @media screen {
//     .pagebreak {
//       display: none; /* Hide page breaks on screen */
//     }
//   }

//   @media print {
//     .pagebreak {
//       page-break-before: always; /* Ensure page break before */
//     }

//     body {
//       -webkit-print-color-adjust: exact; /* Ensure colors are printed accurately */
//       print-color-adjust: exact;
//       margin: 0; /* Override default browser margins */
//         margin: 0; /* Ensures full-page printing */
//     }

//     * {
//       -webkit-box-shadow: none !important;
//       box-shadow: none !important;
//       text-shadow: none !important;
//     }
//   }
// `;

export const pageStyleGrocery = `@page {
  size: A4;
  margin:1mm;
}

@media all {
  .pagebreak {
    display: none;
  }
}

@media print {
  .pagebreak {
    page-break-before: always;
  }
}`;
